<app-default-layout>
  <div class="min-h-screen flex items-center justify-center bg-gray-100 px-4">
    <div class="w-full max-w-sm bg-white p-6 rounded-2xl shadow-md">
      <h1 class="text-2xl font-semibold text-gray-800 mb-6 text-center">Login</h1>
      <form 
        (ngSubmit)="submit()" 
        [formGroup]="form" 
        class="flex flex-col space-y-4"
        [ngClass]="{
          'opacity-50 pointer-events-none': form.disabled
        }">
        <app-text-form-control 
          formControlName="username" 
          label="Email" 
          type="email"
          [errorDisplayMode]="errorDisplayMode.Touched"
        />
        <app-text-form-control 
          formControlName="password" 
          label="Password" 
          type="password" 
          [errorDisplayMode]="errorDisplayMode.Touched"
        />
        <button 
          type="submit" 
          class="btn mt-3"
          [ngClass]="{
            'opacity-50 pointer-events-none': form.invalid
          }">
          Login
        </button>
      </form>
    </div>
  </div>
</app-default-layout>